// Reconstructed from production code; original paths and local names were not available.
import { AppLoading } from "../components/AppLoading.jsx";
import { MEDIA_BASE_URL } from "../services/config.js";
import { ProductCard } from "../components/ProductCard.jsx";
import React from "react";
import { Seo } from "../components/Seo.jsx";
import { api } from "../services/api.js";
import { canonicalUrl } from "../utils/seo.js";
import { hasUnknownQueryParams } from "../utils/seo.js";
import * as jsxRuntime from "react/jsx-runtime";
import { siteOrigin } from "../utils/seo.js";
import { useLanguage } from "../context/LanguageContext.jsx";
import { useLocation } from "react-router-dom";
import { useTheme } from "../context/ThemeContext.jsx";
function catalogMediaUrl(l) {
  return l ? (l.startsWith("http") ? l : `${MEDIA_BASE_URL}${l}`) : "";
}
function catalogImage(l) {
  return (
    l?.image_url ||
    l?.main_image_url ||
    (l?.images && l.images[0]?.image_url) ||
    ""
  );
}
const CATALOG_PAGE_SIZE = 12;
function ProductsPage() {
  const l = useLocation(),
    { theme: theme } = useTheme(),
    { language: language, t: t, tProd: tProd, tText, locale } = useLanguage(),
    [f, m] = React.useState(true),
    [y, g] = React.useState([]),
    [p, b] = React.useState(true),
    [x, O] = React.useState(""),
    [H, E] = React.useState(""),
    [M, N] = React.useState(""),
    [T, Y] = React.useState("newest"),
    [$, I] = React.useState(false),
    [K, J] = React.useState([]),
    [Q, W] = React.useState(false),
    [te, oe] = React.useState(""),
    [he, be] = React.useState(true),
    fe = React.useRef(null),
    pe = React.useRef(false),
    ye = React.useRef(0),
    R = React.useRef(true);
  React.useEffect(() => {
    async function ce() {
      try {
        const Ee = await api.get("/categories");
        g(Ee.data || []);
      } catch (Ee) {
        console.error(Ee);
      } finally {
        m(false);
        b(false);
      }
    }
    ce();
  }, []);
  const B = React.useCallback(
    async (ce = false) => {
      if (pe.current || (!R.current && !ce)) return;
      const Ee = ce ? 0 : ye.current,
        Xe = {
          limit: CATALOG_PAGE_SIZE,
          offset: Ee,
        };
      x && (Xe.categoryId = x);
      H && (Xe.subcategoryId = H);
      pe.current = true;
      W(true);
      oe("");
      try {
        const xe = await api.get("/products", {
            params: Xe,
          }),
          Ie = Array.isArray(xe.data) ? xe.data : [];
        ye.current = Ee + Ie.length;
        J((wt) => (ce ? Ie : [...wt, ...Ie]));
        R.current = Ie.length === CATALOG_PAGE_SIZE;
        be(R.current);
      } catch (xe) {
        console.error(xe);
        oe(
          language === "ar"
            ? "فشل تحميل المنتجات."
            : "Failed to load products.",
        );
      } finally {
        W(false);
        pe.current = false;
      }
    },
    [x, H, language],
  );
  React.useEffect(() => {
    ye.current = 0;
    R.current = true;
    J([]);
    be(true);
    oe("");
    B(true);
  }, [x, H, B]);
  React.useEffect(() => {
    const ce = fe.current;
    if (!ce) return;
    const Ee = new IntersectionObserver(
      (Xe) => {
        Xe[0]?.isIntersecting && B();
      },
      {
        rootMargin: "220px",
      },
    );
    Ee.observe(ce);
    return () => Ee.disconnect();
  }, [B]);
  const F = React.useMemo(
      () => y.find((ce) => String(ce.id) === String(x)),
      [y, x],
    ),
    re = F?.subcategories || [],
    ge = H ? re.find((ce) => String(ce.id) === String(H)) : null,
    j = React.useMemo(() => {
      const ce = M.trim().toLowerCase(),
        Ee = (xe) => {
          const Ie = Number(xe.price || 0),
            wt = Number(xe.sale_price || 0);
          return Number.isFinite(wt) && wt > 0 && wt < Ie ? wt : Ie;
        },
        Xe = ce
          ? K.filter((xe) =>
              [
                xe.name,
                xe.short_description,
                xe.description,
                xe.category_name,
                xe.subcategory_name,
                tProd(xe.name, xe, "name"), tProd(xe.short_description, xe, "short_description"), tProd(xe.description, xe, "description"), tProd(xe.category_name), tProd(xe.subcategory_name),
              ]
                .filter(Boolean)
                .join(" ")
                .toLowerCase()
                .includes(ce),
            )
          : [...K];
      switch (T) {
        case "price-asc":
          return Xe.sort((xe, Ie) => Ee(xe) - Ee(Ie));
        case "price-desc":
          return Xe.sort((xe, Ie) => Ee(Ie) - Ee(xe));
        case "name":
          return Xe.sort((xe, Ie) =>
            String(tProd(xe.name, xe, "name") || "").localeCompare(String(tProd(Ie.name, Ie, "name") || ""), locale),
          );
        default:
          return Xe;
      }
    }, [K, M, T, tProd, locale]),
    A = () => {
      O("");
      E("");
      N("");
      Y("newest");
    },
    X = siteOrigin(),
    q = theme?.site_name || "MyShop",
    Z = canonicalUrl(X, "/products"),
    ee = hasUnknownQueryParams(l.search),
    ie = language === "ar" ? "جميع المنتجات" : "All products",
    Ce =
      language === "ar"
        ? "تصفح المنتجات والتصنيفات والخيارات المتاحة في كتالوج واضح."
        : "Browse products, categories, and available options in a clear, organized catalog.",
    _e = F
      ? ge
        ? `${tProd(F.name, F, "name")} - ${tProd(ge.name, ge, "name")}`
        : tProd(F.name, F, "name")
      : language === "ar"
        ? "جميع المنتجات"
        : "All Products",
    ut = K.length ? catalogMediaUrl(catalogImage(K[0])) : theme?.logo || null,
    gt =
      Z && K.length
        ? {
            "@context": "https://schema.org",
            "@type": "ItemList",
            "@id": `${Z}#product-list`,
            name: ie,
            numberOfItems: K.length,
            itemListElement: K.slice(0, 12).map((ce, Ee) => {
              const Xe = catalogMediaUrl(catalogImage(ce));
              return {
                "@type": "ListItem",
                position: Ee + 1,
                item: canonicalUrl(X, `/products/${ce.public_slug || ce.id}`),
                name: tProd(ce.name, ce, "name"),
                image: Xe || void 0,
              };
            }),
          }
        : null,
    At = Z
      ? {
          "@context": "https://schema.org",
          "@type": "CollectionPage",
          "@id": `${Z}#collection`,
          name: ie,
          description: Ce,
          url: Z,
          image: ut || void 0,
          isPartOf: {
            "@id": `${canonicalUrl(X, "/")}#website`,
          },
          mainEntity: gt
            ? {
                "@id": `${Z}#product-list`,
              }
            : void 0,
        }
      : null;
  return f ? (
    <jsxRuntime.Fragment>
      <Seo
        title={ie}
        description={Ce}
        image={ut}
        imageAlt={ie}
        canonicalUrl={Z || void 0}
        type={"website"}
        siteName={q}
        language={language}
        noindex={ee}
        schema={[At, gt].filter(Boolean)}
      />
      <AppLoading
        variant={"page"}
        layout={"catalog"}
        brand={q}
        label={t("loadingProducts")}
        detail={
          language === "ar"
            ? "يتم تجهيز الكتالوج والفلاتر."
            : "Preparing the catalog and its filters."
        }
      />
    </jsxRuntime.Fragment>
  ) : (
    <div className={"page products-page storefront-page catalog-page"}>
      <Seo
        title={ie}
        description={Ce}
        image={ut}
        imageAlt={ie}
        canonicalUrl={Z || void 0}
        type={"website"}
        siteName={q}
        language={language}
        noindex={ee}
        schema={[At, gt].filter(Boolean)}
      />
      <section className={"home-all-products catalog-experience"}>
        <div className={"products-hero"}>
          <span className={"section-kicker"}>{q}</span>
          <h1>{_e}</h1>
          <p>{t("heroSubtitle")}</p>
        </div>
        <div className={"catalog-category-rail"} aria-label={t("categories")}>
          <button
            type={"button"}
            className={x ? "" : "active"}
            onClick={() => {
              O("");
              E("");
            }}
          >
            {language === "ar" ? "الكل" : tText("All")}
          </button>
          {y.map((ce) => (
            <button
              type={"button"}
              className={String(x) === String(ce.id) ? "active" : ""}
              onClick={() => {
                O(String(ce.id));
                E("");
              }}
              key={ce.id}
            >
              {tProd(ce.name, ce, "name")}
            </button>
          ))}
        </div>
        {re.length > 0 && (
          <div
            className={"catalog-subcategory-rail"}
            aria-label={tText("Subcategories")}
          >
            <button
              type={"button"}
              className={H ? "" : "active"}
              onClick={() => E("")}
            >
              {language === "ar"
                ? `كل ${tProd(F?.name, F, "name")}`
                : `All ${tProd(F?.name, F, "name")}`}
            </button>
            {re.map((ce) => (
              <button
                type={"button"}
                className={String(H) === String(ce.id) ? "active" : ""}
                onClick={() => E(String(ce.id))}
                key={ce.id}
              >
                {tProd(ce.name, ce, "name")}
              </button>
            ))}
          </div>
        )}
        <div
          className={`products-filter-menu catalog-filter-menu${$ ? " is-mobile-open" : ""}`}
        >
          <div className={"catalog-mobile-tool-row"}>
            <div className={"catalog-mobile-tool-copy"}>
              <span>
                {language === "ar" ? "تسوّق بسهولة" : "Shop with ease"}
              </span>
              <strong>
                {language === "ar"
                  ? "ابحث، صفِّ ورتّب"
                  : "Search, filter, sort"}
              </strong>
            </div>
            <button
              type={"button"}
              className={"catalog-mobile-filter-toggle"}
              aria-expanded={$}
              aria-controls={"catalog-advanced-filters"}
              onClick={() => I((ce) => !ce)}
            >
              <span
                aria-hidden={"true"}
                className={"catalog-mobile-filter-icon"}
              >
                {"≡"}
              </span>
              {language === "ar" ? "الفلاتر" : "Filters"}
              <span
                aria-hidden={"true"}
                className={"catalog-mobile-filter-chevron"}
              >
                {"⌄"}
              </span>
            </button>
          </div>
          <label className={"catalog-search"}>
            <span>{language === "ar" ? "البحث" : "Search"}</span>
            <input
              value={M}
              onChange={(ce) => N(ce.target.value)}
              placeholder={t("searchPlaceholder")}
            />
          </label>
          <div
            className={"products-filter-card"}
            id={"catalog-advanced-filters"}
          >
            <div className={"products-filter-group"}>
              <span className={"products-filter-label"}>
                {language === "ar" ? "التصنيف" : tText("Category")}
              </span>
              <select
                className={"products-filter-select"}
                aria-label={tText("Category")}
                value={x}
                onChange={(ce) => {
                  O(ce.target.value);
                  E("");
                }}
                disabled={p}
              >
                <option value={""}>{t("allCategories")}</option>
                {y.map((ce) => (
                  <option value={ce.id} key={ce.id}>
                    {tProd(ce.name, ce, "name")}
                  </option>
                ))}
              </select>
            </div>
            <div className={"products-filter-group"}>
              <span className={"products-filter-label"}>
                {language === "ar" ? "تصنيف فرعي" : tText("Subcategory")}
              </span>
              <select
                className={"products-filter-select"}
                aria-label={tText("Subcategory")}
                value={H}
                onChange={(ce) => E(ce.target.value)}
                disabled={!x || re.length === 0}
              >
                <option value={""}>{language === "ar" ? "الكل" : tText("All")}</option>
                {re.map((ce) => (
                  <option value={ce.id} key={ce.id}>
                    {tProd(ce.name, ce, "name")}
                  </option>
                ))}
              </select>
            </div>
            <div className={"products-filter-group"}>
              <span className={"products-filter-label"}>
                {language === "ar" ? "الترتيب" : "Sort By"}
              </span>
              <select
                className={"products-filter-select"}
                aria-label={tText("Sort")}
                value={T}
                onChange={(ce) => Y(ce.target.value)}
              >
                <option value={"newest"}>
                  {language === "ar" ? "الأحدث" : "Newest"}
                </option>
                <option value={"price-asc"}>
                  {language === "ar"
                    ? "السعر: من الأقل للأعلى"
                    : "Price: Low to High"}
                </option>
                <option value={"price-desc"}>
                  {language === "ar"
                    ? "السعر: من الأعلى للأقل"
                    : "Price: High to Low"}
                </option>
                <option value={"name"}>
                  {language === "ar" ? "الاسم (أ-ي)" : "Name (A-Z)"}
                </option>
              </select>
            </div>
          </div>
          {(x || H || M || T !== "newest") && (
            <button
              type={"button"}
              className={"products-filter-reset"}
              onClick={A}
            >
              {language === "ar" ? "إعادة تعيين" : "Reset"}
            </button>
          )}
        </div>
        <div className={"catalog-result-bar"}>
          <span>
            {j.length} {language === "ar" ? "منتج" : tText("Products")}
          </span>
          <strong>
            {tProd(
              ge?.name ||
                F?.name ||
                (language === "ar" ? "جميع المنتجات" : "All Products"),
            )}
          </strong>
        </div>
        {(F || ge || M || T !== "newest") && (
          <div className={"catalog-active-chips"} aria-label={"Active Filters"}>
            {F && <span>{tProd(F.name, F, "name")}</span>}
            {ge && <span>{tProd(ge.name, ge, "name")}</span>}
            {M && (
              <span>{language === "ar" ? `البحث: ${M}` : `Search: ${M}`}</span>
            )}
            {T !== "newest" && (
              <span>{language === "ar" ? `ترتيب: ${T}` : `Sort: ${T}`}</span>
            )}
          </div>
        )}
        <div className={"home-products-scroll"}>
          {j.length === 0 && !Q && !te && (
            <p
              className={"home-products-empty"}
              style={{
                textAlign: "center",
                padding: "4rem",
                color: "var(--text-muted)",
              }}
            >
              {language === "ar"
                ? "لا توجد منتجات في هذا التصنيف."
                : "No products found in this category."}
            </p>
          )}
          <div className={"product-grid catalog-product-grid"}>
            {j.map((ce, Ee) => (
              <ProductCard product={ce} priority={Ee < 4} key={ce.id} />
            ))}
          </div>
          {te && (
            <p
              style={{
                color: "#e05b3f",
                textAlign: "center",
                padding: "1rem",
              }}
            >
              {te}
            </p>
          )}
          {Q && (
            <AppLoading
              variant={"section"}
              layout={"table"}
              className={"catalog-products-loading"}
              label={
                language === "ar"
                  ? "جاري تحميل المزيد من المنتجات…"
                  : "Loading more products…"
              }
            />
          )}
          {!he && K.length > 0 && (
            <p
              style={{
                textAlign: "center",
                padding: "1.5rem",
                color: "var(--text-muted)",
                fontSize: "0.85rem",
              }}
            >
              {language === "ar" ? "نهاية الكتالوج" : "End of catalog."}
            </p>
          )}
          <div ref={fe} />
        </div>
      </section>
    </div>
  );
}
export { catalogMediaUrl, catalogImage, CATALOG_PAGE_SIZE, ProductsPage };
